var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bss-slide-in-wrapper\" ng-class=\"{locked: locked}\">\n<div class=\"bss-slide-in-trigger\">\n<i ng-class=\"triggerClass()\"></i> <span class=\"bss-slide-in-instruction\">clicca per <span ng-if=\"locked\">s</span>bloccare</span>\n</div>\n<div class=\"bss-slide-in-content jumbotron\">\n<ng-transclude></ng-transclude>\n</div>\n</div>";
var id1="bssslidein.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;